import type { MetroLine } from '../domain/types';

interface LineDotsProps {
  lines: readonly MetroLine[];
  labelled?: boolean;
}

export function LineDots({ lines, labelled = true }: LineDotsProps) {
  const label = lines.map((line) => line.name).join(', ');
  return (
    <span className="line-dots" aria-label={labelled ? label : undefined} aria-hidden={labelled ? undefined : true}>
      {lines.map((line) => (
        <span key={line.id} className="line-dot" style={{ backgroundColor: line.color }} title={line.name} />
      ))}
    </span>
  );
}
